/* unplugin-vue-components disabled */import script from "./ActivityConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityConfirm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__